import type { CoinBalance } from '../api/types';
import { useT } from '../i18n';
/**
 * `compact`: kurze Fassung fuer enge Flaechen (Coin-Pille der Kopfzeile). Der
 * lange Satz „Zuege in dieser Stufe unbegrenzt" machte die Pille auf Handys so
 * breit, dass sie das Logo verdraengte (C45).
 */
export function TurnsRemaining({ data, surface = 'adventure', compact = false }: { data?: CoinBalance; surface?: 'adventure' | 'chat'; compact?: boolean }) {
  const { t } = useT();
  const turns = data?.turns?.[surface];
  if (!turns) return null;
  const count = Number(data?.balance) < 0 ? 0
    : Math.floor(Math.max(0, Number(data?.balance) || 0) / Math.max(1, turns.coins_per_turn)) + turns.free_turns;
  return <span>{t(turns.unlimited && Number(data?.balance) >= 0 ? (compact ? 'a5.unlimited_short' : 'a5.unlimited') : 'a5.turns_left', { turns: count })}</span>;
}
